import {
  createUserPlanPlanCreateLessonIdGetQueryKey,
  validateUserPlanPlanValidatePostMutation,
} from '@/client/@tanstack/react-query.gen'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { logger } from '@/utils'
import { useAuthHeaders } from '@/providers'

const log = logger.child({
  file: 'src/hooks/useSubmitLessonToGetFeedbackMutation.tsx',
})

export const useSubmitLessonToGetFeedbackMutation = ({
  lessonId,
}: {
  lessonId: string
}) => {
  const headers = useAuthHeaders()
  const queryClient = useQueryClient()
  return useMutation({
    ...validateUserPlanPlanValidatePostMutation({ headers }),
    onSuccess: (data) => {
      log.info({ msg: 'Feedback submitted successfully', data })
      queryClient.invalidateQueries({
        queryKey: createUserPlanPlanCreateLessonIdGetQueryKey({
          path: { lesson_id: lessonId },
        }),
      })
    },
    onError: (error) => {
      log.error({ msg: 'Error submitting feedback', error })
    },
  })
}
